<div class="header">
  <h1>{{headline}}</h1>
  <div class="header-line"></div>
</div>
